import { useCallback } from 'react';
import { IndexedStep } from 'components/Wizard';
import { UseVideoSubFlow, VideoFlowStep } from '../types';
import useDestinationStep from '../useDestinationStep';
import useUploadVideoStep from '../useUploadVideoStep';

const useMultiClipSubFlow: UseVideoSubFlow = ({
  onError,
  state,
  stateDispatch,
  wizardRef,
}) => {
  const { reset, step: uploadVideoStep } = useUploadVideoStep({
    objective: 'MultipleClips',
    onError,
    state,
    stateDispatch,
    wizardRef,
  });

  const { step: destinationStep } = useDestinationStep({
    state,
    stateDispatch,
    wizardRef,
  });

  const handleStepChange = useCallback(
    (toStep: IndexedStep<VideoFlowStep>) => {
      if (toStep.stepId === VideoFlowStep.UPLOAD_VIDEO) {
        reset();
      }
    },
    [reset],
  );

  return {
    onStepChange: handleStepChange,
    steps: [uploadVideoStep, destinationStep],
  };
};

export default useMultiClipSubFlow;
